import { render, staticRenderFns } from "./sideNavigation.vue?vue&type=template&id=7ff01f67&"
import script from "./sideNavigation.vue?vue&type=script&lang=js&"
export * from "./sideNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports